<li class="nav-item" *ngIf="turns.length != 0">
  <button [ngClass]="{'animated pulse infinite': turns.length }" class="nav-link btn btn-info me-2" (click)="openModal()"><i class="fa fa-level-up" aria-hidden="true"></i>
    {{ "queueDesk" | language }}
    <span *ngIf="turns.length > 0" class="badge rounded-pill text-bg-danger">{{ turns.length }}</span></button>

</li>

<app-modal [id]="'deskQueueModal'" [ultralarge]="true">
  <div modal-title>{{ "queueDesk" | language }}</div>
  <div modal-body>
    <div class="alert alert-warning" *ngIf="turns.length == 0">{{ 'queueEmpty' | language }}</div>
    <div class="row" *ngIf="turns.length > 0">
      <div class="col-md-12">
        <input type="search" class="w-25 form-control float-end mb-3" [placeholder]="'search' | language" [(ngModel)]="search">
        <table class="table table-striped">
          <thead>
            <tr>
              <th (click)="orderBy('label')" scope="col">
                {{ 'turn' | language }}
                <i *ngIf="orderType == 'label' && !orderReverse" class="fa fa-caret-up" aria-hidden="true"></i>
                <i *ngIf="orderType == 'label' && orderReverse" class="fa fa-caret-down" aria-hidden="true"></i>
              </th>
              <th (click)="orderBy('clientname')" scope="col">
                {{ 'client' | language }}
                <i *ngIf="orderType == 'clientname' && !orderReverse" class="fa fa-caret-up" aria-hidden="true"></i>
                <i *ngIf="orderType == 'clientname' && orderReverse" class="fa fa-caret-down" aria-hidden="true"></i>
              </th>
              <th (click)="orderBy('clientid')" scope="col">
                {{ 'cclient' | language }}
                <i *ngIf="orderType == 'clientid' && !orderReverse" class="fa fa-caret-up" aria-hidden="true"></i>
                <i *ngIf="orderType == 'clientid' && orderReverse" class="fa fa-caret-down" aria-hidden="true"></i>
              </th>
              <th (click)="orderBy('prekindname')" scope="col">
                {{ 'actualKind' | language }}
                <i *ngIf="orderType == 'prekindname' && !orderReverse" class="fa fa-caret-up" aria-hidden="true"></i>
                <i *ngIf="orderType == 'prekindname' && orderReverse" class="fa fa-caret-down" aria-hidden="true"></i>
              </th>
              <th (click)="orderBy('initdatetime')" scope="col">
                {{ 'ticketDate' | language }}
                <i *ngIf="orderType == 'initdatetime' && !orderReverse" class="fa fa-caret-up" aria-hidden="true"></i>
                <i *ngIf="orderType == 'initdatetime' && orderReverse" class="fa fa-caret-down" aria-hidden="true"></i>
              </th>
              <th (click)="orderBy('deskdatetime')" scope="col">
                {{ 'attentionDate' | language }}
                <i *ngIf="orderType == 'deskdatetime' && !orderReverse" class="fa fa-caret-up" aria-hidden="true"></i>
                <i *ngIf="orderType == 'deskdatetime' && orderReverse" class="fa fa-caret-down" aria-hidden="true"></i>
              </th>
              <th (click)="orderBy('rdcomment')" scope="col">
                {{ 'observations' | language }}
                <i *ngIf="orderType == 'rdcomment' && !orderReverse" class="fa fa-caret-up" aria-hidden="true"></i>
                <i *ngIf="orderType == 'rdcomment' && orderReverse" class="fa fa-caret-down" aria-hidden="true"></i>
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of turns | orderBy:orderType : orderReverse : false | filterBy: search; let i = index">
              <td>{{ t.label }}</td>
              <td>{{ t.clientname }}</td>
              <td>{{ t.clientid }}</td>
              <td>{{ t.prekindname }}</td>
              <td>{{ t.initdatetime | date: 'HH:mm' }}</td>
              <td>{{ t.deskdatetime | date: 'HH:mm' }}</td>
              <td>{{ t.rdcomment }}</td>
              <td class="text-right">
                <button class="btn btn-success btn-sm" (click)="call(t.id)"><i class="fa fa-bell" aria-hidden="true"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</app-modal>
